import { render } from "./Award.vue?vue&type=template&id=53dd2489&scoped=true"
import script from "./Award.vue?vue&type=script&lang=js"
export * from "./Award.vue?vue&type=script&lang=js"

import "./Award.vue?vue&type=style&index=0&id=53dd2489&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53dd2489"]])

export default __exports__